import React, {Fragment} from 'react';
import {EmailIcon} from 'components/vectors'

const EmailSettings = props =>  (
    <Fragment>
        <div className="d-flex flex-row ">
            <EmailIcon />
            <p className="text--medium text--black ml-3">Email Settings</p>
        </div>
        <div className="mt-4">
            <div className="d-flex flex-row">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Pandora streams</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Pandora spins</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">DSTV</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">TV Data - Abuja</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">TV Data - Abuja</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Radio Data - Lagos</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Radio Data - Abuja</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Artist Notification</p>
            </div>
            <div className="d-flex flex-row my-2">
                <input type="checkbox"  className="mr-3"/>
                <p className="text--small text--grey">Weekly Report</p>
            </div>
        </div>

        <div className="row profile-action__container">
            <div className="col-md-4 ml-auto">
                <div className="box box-xs box--grey nsForm-btn">Save Changes</div>
            </div>
        </div>
    </Fragment>
);

export default EmailSettings;